import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    slotsList: null,
    slotsListLoading: false
};

export const slotsAction = createAsyncThunk('slotsAction', async (payload, { dispatch }) => {
    dispatch(setSlotsListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/slots';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setSlotsListLoading(false))
                return data

            case 'post':
                ({ data } = await ax.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Временный слот успешно отредактирован`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Временный слот успешно добавлен`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Временный слот успешно удален`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setSlotsListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const SlotsSlice = createSlice({
    name: 'slots',
    initialState,
    reducers: {
        setSlotsListLoading: (state, action) => {
            state.slotsListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(slotsAction.fulfilled, (state, action) => {
            state.slotsList = action.payload
        })
    }
});

export const { setSlotsListLoading } = SlotsSlice.actions;

export default SlotsSlice.reducer